import { ContentItemAccount } from './ContentItemAccount';
import {ContentItemCategory} from "./ContentItemCategory";

export class ContentItem implements IContentItem {
    id?: string;
    dateCreated?: Date;
    dateUpdated?: Date;
    createdByPersonId?: string | undefined;
    updatedByPersonId?: string | undefined;
    title?: string | undefined;
    platformId?: string | undefined;
    contentItemCategoryId?: string | undefined;
    contentItemTypeId?: string | undefined;
    fileId?: string | undefined;
    thumbFileId?: string | undefined;
    metadataFileId?: string | undefined;
    notes?: string | undefined;
    isAllAccounts?: boolean;
    isDisabled?: boolean;
    dateDisabled?: Date | undefined;
    disabledByPersonId?: string | undefined;
    contentItemCategory?: ContentItemCategory | undefined;
    contentItemAccounts?: ContentItemAccount[] | undefined;

    constructor(data?: IContentItem) {
        if (data) {
            for (const property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.dateCreated = _data["dateCreated"] ? new Date(_data["dateCreated"].toString()) : <any>undefined;
            this.dateUpdated = _data["dateUpdated"] ? new Date(_data["dateUpdated"].toString()) : <any>undefined;
            this.createdByPersonId = _data["createdByPersonId"];
            this.updatedByPersonId = _data["updatedByPersonId"];
            this.title = _data["title"];
            this.platformId = _data["platformId"];
            this.contentItemCategoryId = _data["contentItemCategoryId"];
            this.contentItemTypeId = _data["contentItemTypeId"];
            this.fileId = _data["fileId"];
            this.thumbFileId = _data["thumbFileId"];
            this.metadataFileId = _data["metadataFileId"];
            this.notes = _data["notes"];
            this.isAllAccounts = _data["isAllAccounts"];
            this.isDisabled = _data["isDisabled"];
            this.dateDisabled = _data["dateDisabled"] ? new Date(_data["dateDisabled"].toString()) : <any>undefined;
            this.disabledByPersonId = _data["disabledByPersonId"];
            this.contentItemCategory = _data["contentItemCategory"] ? ContentItemCategory.fromJS(_data["contentItemCategory"]) : <any>undefined;
            if (Array.isArray(_data["contentItemAccounts"])) {
                this.contentItemAccounts = [] as any;
                for (const item of _data["contentItemAccounts"])
                    this.contentItemAccounts!.push(ContentItemAccount.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ContentItem {
        data = typeof data === 'object' ? data : {};
        const result = new ContentItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["dateCreated"] = this.dateCreated ? this.dateCreated.toISOString() : <any>undefined;
        data["dateUpdated"] = this.dateUpdated ? this.dateUpdated.toISOString() : <any>undefined;
        data["createdByPersonId"] = this.createdByPersonId;
        data["updatedByPersonId"] = this.updatedByPersonId;
        data["title"] = this.title;
        data["platformId"] = this.platformId;
        data["contentItemCategoryId"] = this.contentItemCategoryId;
        data["contentItemTypeId"] = this.contentItemTypeId;
        data["fileId"] = this.fileId;
        data["thumbFileId"] = this.thumbFileId;
        data["metadataFileId"] = this.metadataFileId;
        data["notes"] = this.notes;
        data["isAllAccounts"] = this.isAllAccounts;
        data["isDisabled"] = this.isDisabled;
        data["dateDisabled"] = this.dateDisabled ? this.dateDisabled.toISOString() : <any>undefined;
        data["disabledByPersonId"] = this.disabledByPersonId;
        data["contentItemCategory"] = this.contentItemCategory ? this.contentItemCategory.toJSON() : <any>undefined;
        if (Array.isArray(this.contentItemAccounts)) {
            data["contentItemAccounts"] = [];
            for (const item of this.contentItemAccounts)
                data["contentItemAccounts"].push(item.toJSON());
        }
        return data;
    }
}

export interface IContentItem {
    id?: string;
    dateCreated?: Date;
    dateUpdated?: Date;
    createdByPersonId?: string | undefined;
    updatedByPersonId?: string | undefined;
    title?: string | undefined;
    platformId?: string | undefined;
    contentItemCategoryId?: string | undefined;
    contentItemTypeId?: string | undefined;
    fileId?: string | undefined;
    thumbFileId?: string | undefined;
    metadataFileId?: string | undefined;
    notes?: string | undefined;
    isAllAccounts?: boolean;
    isDisabled?: boolean;
    dateDisabled?: Date | undefined;
    disabledByPersonId?: string | undefined;
    contentItemCategory?: ContentItemCategory | undefined;
    contentItemAccounts?: ContentItemAccount[] | undefined;
}